(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lacey-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-lacey-sort]')) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', e.target.value);
    u.searchParams.delete('page');
    window.location.assign(u.toString());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lacey-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindAll() {
      document.querySelectorAll('.lacey-header').forEach(function (header) {
        var drawer = header.querySelector('[data-lacey-menu-drawer]');
        if (drawer) {
          header.querySelectorAll('[data-lacey-menu-open]').forEach(function (btn) {
            btn.addEventListener('click', function () { drawer.hidden = false; });
          });
          header.querySelectorAll('[data-lacey-menu-close]').forEach(function (el) {
            el.addEventListener('click', function () { drawer.hidden = true; });
          });
        }

        // Announcement bar rotator: cycles between messages if 2+ are present.
        var announce = header.querySelector('[data-lacey-announce]');
        if (announce && !announce.__laceyRotator) {
          var msgs = announce.querySelectorAll('[data-lacey-announce-msg]');
          if (msgs.length > 1) {
            var ms = parseInt(announce.dataset.rotateMs, 10) || 5000;
            var idx = 0;
            announce.__laceyRotator = setInterval(function () {
              msgs[idx].classList.remove('is-active');
              idx = (idx + 1) % msgs.length;
              msgs[idx].classList.add('is-active');
            }, ms);
          }
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindAll);
    } else {
      bindAll();
    }
    document.addEventListener('shopify:section:load', bindAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lacey-login"]) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.lacey-auth').forEach(function (root) {
        var login = root.querySelector('#lacey-login');
        var recover = root.querySelector('#lacey-recover');
        if (!login || !recover) return;
        var showRecover = function (e) { if (e) e.preventDefault(); login.hidden = true; recover.hidden = false; location.hash = '#recover'; };
        var showLogin   = function (e) { if (e) e.preventDefault(); recover.hidden = true; login.hidden = false; location.hash = '#login'; };
        root.querySelectorAll('[data-lacey-show-recover]').forEach(function (a) { a.addEventListener('click', showRecover); });
        root.querySelectorAll('[data-lacey-show-login]').forEach(function (a) { a.addEventListener('click', showLogin); });
        if (location.hash === '#recover') { showRecover(); }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lacey-product"]) return;
  try {
    
  (function () {
    function init() {
      // Quantity controls
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lacey-qty]');
        if (!btn) return;
        var input = btn.parentElement.querySelector('input');
        if (!input) return;
        var delta = parseInt(btn.dataset.laceyQty, 10) || 0;
        var current = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = current;
      });

      // Tabs
      document.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-lacey-tab]');
        if (!tab) return;
        var root = tab.closest('[data-lacey-tabs]');
        if (!root) return;
        var name = tab.dataset.laceyTab;
        root.querySelectorAll('[data-lacey-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        root.querySelectorAll('[data-lacey-panel]').forEach(function (p) { p.hidden = p.dataset.laceyPanel !== name; });
      });

      // Variant pickers
      var dataNode = document.querySelector('[data-lacey-product-data]');
      if (!dataNode) return;
      var productData;
      try { productData = JSON.parse(dataNode.textContent); } catch (e) { return; }
      var variants = productData.variants || [];
      var form = document.getElementById('lacey-product-form');
      if (!form) return;
      var idInput = form.querySelector('[data-lacey-variant-id]');
      var priceEl = document.querySelector('[data-lacey-price]');
      var priceCompareEl = document.querySelector('[data-lacey-price-compare]');
      var atcBtn = form.querySelector('button[name="add"]');

      function moneyFormat(cents) {
        var dollars = (cents / 100);
        var hasFraction = (cents % 100) !== 0;
        return '$' + (hasFraction ? dollars.toFixed(2) : Math.round(dollars));
      }

      function syncFromActiveButtons() {
        var groups = form.querySelectorAll('.lacey-pdp__variants');
        var selected = [];
        groups.forEach(function (g) {
          var active = g.querySelector('.lacey-pdp__variant.is-active');
          if (active) selected.push(active.dataset.laceyVariantValue);
        });
        if (selected.length === 0) return;
        var match = variants.find(function (v) {
          return (v.options || []).every(function (val, i) { return val === selected[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = moneyFormat(match.price);
        if (priceCompareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceCompareEl.textContent = moneyFormat(match.compare_at_price);
            priceCompareEl.hidden = false;
          } else {
            priceCompareEl.hidden = true;
          }
        }
        if (atcBtn) {
          if (match.available) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'ADD TO CART';
            atcBtn.classList.remove('lacey-pdp__atc--sold');
          } else {
            atcBtn.disabled = true;
            atcBtn.textContent = 'SOLD OUT';
            atcBtn.classList.add('lacey-pdp__atc--sold');
          }
        }
      }

      form.addEventListener('click', function (e) {
        var btn = e.target.closest('.lacey-pdp__variant');
        if (!btn) return;
        e.preventDefault();
        // Toggle active in this group only.
        var group = btn.closest('.lacey-pdp__variants');
        if (group) {
          group.querySelectorAll('.lacey-pdp__variant').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        }
        syncFromActiveButtons();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lacey-register"]) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.lacey-auth form').forEach(function (form) {
        var noteEl = form.querySelector('#lacey-customer-note');
        var bizEl  = form.querySelector('[data-lacey-pro-field="business"]');
        var licEl  = form.querySelector('[data-lacey-pro-field="license"]');
        var stEl   = form.querySelector('[data-lacey-pro-field="state"]');
        if (!noteEl || (!bizEl && !licEl && !stEl)) return;
        form.addEventListener('submit', function () {
          var parts = [];
          if (bizEl && bizEl.value) parts.push('Business: ' + bizEl.value);
          if (licEl && licEl.value) parts.push('License: ' + licEl.value);
          if (stEl  && stEl.value)  parts.push('State: '    + stEl.value);
          if (parts.length) noteEl.value = '[Pro account application] ' + parts.join(' | ');
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
